import { agenticUrl } from "@findemdev/findem-helpers";

/** The existing Candidate Reports proxy also accepts native exec-project refs. */
export const getPresentationTransportBaseUrl = (projectRef: string) =>
  `${agenticUrl}/agentic/api/candidate_reports/${encodeURIComponent(projectRef)}`;

export const getPresentationApiUrl = (projectRef: string, path: string) =>
  `${getPresentationTransportBaseUrl(projectRef)}/agentic/api${path}`;
